import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/2026",
    component: () =>
      import(/* webpackChunkName: "baseLayout" */ "@/layouts/BaseLayout.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "/2026/postulacion/manual",
        name: "manual2026",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/2026/FormularioManualView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/2026/resultados",
        name: "resultado2026",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/2026/FormularioResultadoView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/2026/pronto",
        name: "pronto2026",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/2026/FormularioProntoView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/2026/postulacion-terminada",
        name: "formularioTerminada2026",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/2026/FormularioTerminadoView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/2026/postulacion",
        name: "formulario2026",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/2026/FormularioView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/2026",
        name: "formularioLanding2026",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/2026/FormularioLandingView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
